"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { usePathname } from "next/navigation";
import Modal from "@/components/Modal";
import BirthdateForm from "@/components/BirthdateForm";
import { useTranslations } from "@/providers/TranslationsProvider";
import type { User } from "@/types/user";

/** Staff accounts aren't asked. */
const EXEMPT_ROLES = new Set(["admin", "super-admin"]);
/** The terms and privacy policy stay readable before answering. */
const OPEN_PAGES = /^\/[^/]+\/(privacy|terms|contact)(\/|$)/;

/** Whether the gate asks this user; the booking flow waits on the same rule. */
export const needsBirthdate = (user: Pick<User, "birthdate" | "roles"> | null | undefined) => !!user && !user.birthdate && !(user.roles ?? []).some(role => EXEMPT_ROLES.has(role));
interface BirthdateGateProps {
  user: User;
  onSaved: (birthdate: string) => void;
  onSignOut: () => void;
}

/**
 * Asks a signed-in visitor for their birth date when the account has none
 * (older accounts, or a sign-up whose sign-in modal was left mid-step).
 * A fresh sign-up is asked inside the sign-in modal instead. Required, so
 * there's no close button; shown in the same sheet as the sign-in modal.
 */
export default function BirthdateGate(t0) {
  const $ = _c(9);
  const {
    user,
    onSaved,
    onSignOut
  } = t0;
  const {
    t
  } = useTranslations();
  const pathname = usePathname();
  const [minor, setMinor] = useState(false);
  const needed = needsBirthdate(user) && !OPEN_PAGES.test(pathname ?? "");
  if (!needed) {
    return null;
  }
  let t1;
  if ($[0] !== minor || $[1] !== t) {
    t1 = minor ? t("birthdate gate.minor title", "Accounts are for adults") : t("birthdate gate.title", "Date of birth");
    $[0] = minor;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onSaved || $[4] !== onSignOut) {
    t2 = <BirthdateForm onSaved={onSaved} onSignOut={onSignOut} onMinorChange={setMinor} />;
    $[3] = onSaved;
    $[4] = onSignOut;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Modal show={true} onClose={_temp} dismissible={false} mobileCenter={true} title={t1}>{t2}</Modal>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp() {}